var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ApolloClient, ApolloLink, InMemoryCache } from '@apollo/client';
import { makeErrorLink } from './links/error_link';
import { makeHeaderLink } from './links/header_link';
import { makeRetryLink } from './links/retry_link';
import { makeTimeoutLink } from './links/timeout_link';
import { makePerformanceLink } from './links/performance_link';
import { chainHttpLink } from './links/http_link';
export const DEFAULT_OPTIONS = {
    watchQuery: {
        fetchPolicy: 'network-only',
    },
    query: {
        fetchPolicy: 'network-only',
    },
};
export const MAX_REQUEST_ATTEMPTS = 2;
// In ms
export const MAX_REQUEST_DURATION = 10000;
//This operation doesn't have to be async, but we're doing to avoid just displaying nothing while building the client.
export const initApolloClient = (user, apiEndpoint, headerOptions, possibleTypes, includeCredentials, maxRetryCount = MAX_REQUEST_ATTEMPTS, maxTimeoutDuration = MAX_REQUEST_DURATION, enableRetries = true, enableTimeout = true, performanceCallback = undefined) => __awaiter(void 0, void 0, void 0, function* () {
    const performanceLink = performanceCallback ? [makePerformanceLink(performanceCallback)] : [];
    const headerLink = makeHeaderLink(user, headerOptions);
    const errorLink = makeErrorLink();
    const timeoutLink = enableTimeout ? [makeTimeoutLink(maxTimeoutDuration)] : [];
    const retryLink = enableRetries ? [makeRetryLink(maxRetryCount)] : [];
    // The order of this list is semantic, be careful of changes.
    const intermediateLink = ApolloLink.from([headerLink, ...retryLink, errorLink, ...performanceLink, ...timeoutLink]);
    const terminatedLink = chainHttpLink(intermediateLink, apiEndpoint, includeCredentials);
    return new ApolloClient({
        link: terminatedLink,
        cache: new InMemoryCache({ possibleTypes }),
        defaultOptions: DEFAULT_OPTIONS,
    });
});
